import { FC, useEffect, useRef, useState } from "react";
import { VoidFunc } from "../../../../helpers/functions/types";
import { MinMaxArgsType } from "../types";
import { INVALID_INPUT_STYLES } from "../../detailedPages/styles";
import { useInputValidity } from "../../detailedPages/ValidationContext";

export const NumbericAtom: FC<{
  name: string;
  value?: number;
  onChange?: VoidFunc<HTMLInputElement>;
  min?: MinMaxArgsType;
  max?: MinMaxArgsType;
  step?: number | "any";
  srLabel?: boolean;
}> = ({ name, value, onChange, min, max, step, srLabel }) => {
  const [fieldValue, setFieldValue] = useState(String(value ?? ""));

  useEffect(() => {
    setFieldValue(String(value ?? ""));
  }, [value]);

  const inputRef = useRef<HTMLInputElement>(null);
  useInputValidity(inputRef);

  const handleChange = (target: HTMLInputElement) => {
    setFieldValue(target.value);
    onChange?.(target);
  };

  return (
    <input
      ref={inputRef}
      id={name}
      type="number"
      className={`${INVALID_INPUT_STYLES} ${srLabel ? "w-full" : "w-20"} block h-9 rounded-md border border-stone-300 px-2 text-sm shadow-sm focus:border-stone-500 focus:ring-stone-500 dark:border-stone-800 dark:bg-stone-700 dark:text-white  `}
      value={fieldValue}
      onChange={(ev) => {
        handleChange(ev.target);
      }}
      min={min}
      max={max}
      step={step}
    />
  );
};
